export const radiusIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0zm0 2c4.246 0 7.939 3.487 7.939 7H12V8H8v4h4v-1h5.939c0 4.512-4.639 7-7.939 7-4.331 0-8-3.5-8-8 0-4.508 3.53-8.013 8-8z"/></svg>`,
  name: 'radius',
};
